import React, { type ReactNode, useCallback } from 'react';

import { Inline } from '@atlaskit/primitives/compiled';
import {
	VoiceAcceptButton,
	VoiceDictationState,
	VoiceMicrophoneButton,
	VoiceRejectButton,
} from '@atlassian/ai-audio';
import { GettingStartedTourSpotlight } from '@atlassian/conversation-assistant-onboarding';

type VoiceActionsPanelProps = {
	state: VoiceDictationState;
	children: ReactNode;
	isVoiceDictationEnabled?: boolean;
	onStartRecording: () => void;
	onRejectRecording: () => void;
	onAcceptRecording: () => void;
};

export const VoiceActionsPanel = ({
	state,
	onRejectRecording,
	onStartRecording,
	onAcceptRecording,
	children,
	isVoiceDictationEnabled = true,
}: VoiceActionsPanelProps) => {
	const handleOnMicrophoneClick = useCallback(() => {
		if (state !== VoiceDictationState.Recording) {
			onStartRecording();
		}
	}, [state, onStartRecording]);

	if (!isVoiceDictationEnabled) {
		return children;
	}

	switch (state) {
		case VoiceDictationState.Recording:
		case VoiceDictationState.Initializing:
			return (
				<Inline alignBlock="center" space="space.050">
					<VoiceRejectButton onClick={onRejectRecording} />
					<VoiceAcceptButton onClick={onAcceptRecording} />
				</Inline>
			);
		default:
			return (
				<Inline alignBlock="center" space="space.050">
					<GettingStartedTourSpotlight step={3}>
						<VoiceMicrophoneButton onClick={handleOnMicrophoneClick} />
					</GettingStartedTourSpotlight>
					{children}
				</Inline>
			);
	}
};
